import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import {
  mapResourceProfileRebuildRunResult,
  mapResourceProfileRebuildTaskList,
  type ResourceProfileRebuildRunResultRaw,
  type ResourceProfileRebuildTaskListRaw,
} from "../api/adapters";
import type {
  ResourceProfileRebuildRunResult,
  ResourceProfileRebuildTaskList,
} from "../types";

const RESOURCE_PROFILE_REBUILD_OPERATION_TIMEOUT_MS = 300_000;

/** 查询资源画像重算任务列表。 */
export async function fetchResourceProfileRebuildTasks(): Promise<ResourceProfileRebuildTaskList> {
  const response = await httpClient.get<ApiEnvelope<ResourceProfileRebuildTaskListRaw>>(
    "/resource-profile-rebuild/tasks",
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("资源画像重算任务接口返回了无效数据");
  }
  return mapResourceProfileRebuildTaskList(response.data.data);
}

/** 预览单个资源画像重算任务。 */
export async function previewResourceProfileRebuildTask(
  taskKey: string,
): Promise<ResourceProfileRebuildRunResult> {
  const response = await httpClient.post<ApiEnvelope<ResourceProfileRebuildRunResultRaw>>(
    `/resource-profile-rebuild/tasks/${taskKey}/preview`,
    undefined,
    { timeout: RESOURCE_PROFILE_REBUILD_OPERATION_TIMEOUT_MS },
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("资源画像重算预览接口返回了无效数据");
  }
  return mapResourceProfileRebuildRunResult(response.data.data);
}

/** 执行单个资源画像重算任务。 */
export async function executeResourceProfileRebuildTask(
  taskKey: string,
): Promise<ResourceProfileRebuildRunResult> {
  const response = await httpClient.post<ApiEnvelope<ResourceProfileRebuildRunResultRaw>>(
    `/resource-profile-rebuild/tasks/${taskKey}/execute`,
    undefined,
    { timeout: RESOURCE_PROFILE_REBUILD_OPERATION_TIMEOUT_MS },
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("资源画像重算执行接口返回了无效数据");
  }
  return mapResourceProfileRebuildRunResult(response.data.data);
}
